import { render, staticRenderFns } from "./SettingsPaymentWire.vue?vue&type=template&id=6470062e&lang=pug&"
import script from "./SettingsPaymentWire.vue?vue&type=script&lang=js&"
export * from "./SettingsPaymentWire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6470062e')) {
      api.createRecord('6470062e', component.options)
    } else {
      api.reload('6470062e', component.options)
    }
    module.hot.accept("./SettingsPaymentWire.vue?vue&type=template&id=6470062e&lang=pug&", function () {
      api.rerender('6470062e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/settings/SettingsPayment/SettingsPaymentWire.vue"
export default component.exports